import { render } from "./NftDescription.vue?vue&type=template&id=6fe0a461&scoped=true"
import script from "./NftDescription.vue?vue&type=script&lang=js"
export * from "./NftDescription.vue?vue&type=script&lang=js"

import "./NftDescription.vue?vue&type=style&index=0&id=6fe0a461&scoped=true&lang=css"
import "@/Common/Styles/nftDescription.scss?vue&type=style&index=1&id=6fe0a461&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe0a461"]])

export default __exports__